module.exports = __webpack_public_path__ + "ba64cf91fa6832bed71602d26346ec03.svg";